import React, { useState } from 'react';
import SeoHelmets from '../SeoOptimazation/SeoHelmets';
import "../Login/Login.css";
import { Link, useNavigate } from 'react-router-dom';
import { useAlert } from 'react-alert';
import { forgotUser } from '../DynamicCourse/api';
import axios from 'axios';
import swal from "sweetalert";
import { BASE_URL } from '../../insightConfig/insightConfig';

function Forgot() {
    const [email, setEmail] = useState('');
    const navigate = useNavigate();
    const alert = useAlert();
    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/Forget`, { email })
            if (response.data.statusCode ==200){
                swal(response.data.message, {
                    icon: "success",
                    buttons: {
                        confirm: {
                            text: "OK",
                            value: true,
                            visible: true,
                            closeModal: true
                        }
                    }
                }).then(() => {
                    navigate('/login');
                })
            }
            // await forgotUser({ email });
            // // Reset form fields or show success message

            // // If registration is successful, reset form fields and show success message
            // setEmail('');
            // navigate('/login');
            // // alert("Hello, this is an alert!");
            // alert.show('Forget Password Successfully');
        } catch (error) {
            swal(error.response.data.message, { icon: "error" })
            console.error(error.message);
        }
    };
    return (
        <>
            <SeoHelmets 
                title="Forgot Password - Insight IAS Academy" 
                description="Recover your Insight IAS account password. Enter your registered email to receive your login credentials."
            />
            <div className="forgotCOntainer">
                <div className='loginForm forgotForm'>
                    <div className="card login-card">
                        <div className="card-header m-3 text-center fw-500 text-white login-heading">
                            Enter Registered Email-id to Get Password
                        </div>
                        <div className="card-body">
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="exampleInputEmail1" className="form-label">Email address</label>
                                    <input type="email" className="form-control signup-name" id="exampleInputEmail1" placeholder='Your Email-ID' aria-describedby="emailHelp" value={email} onChange={(e) => setEmail(e.target.value.toLowerCase())} style={{ textDecoration: 'none' }} />
                                </div>
                                <div className="d-grid gap-2">
                                    <button className="btn btn-primary login-btn py-2 border-0" type="button" onClick={handleSubmit}>SUBMIT</button>
                                </div>
                            </form>
                        </div>
                        <div className='m-3 login-bottom'>
                            <div className="card-footer py-3 d-flex justify-content-center login-footer">
                                <span className="fw-bold me-1" style={{ color: '#9c0828ff', fontSize: '1.15rem' }}>Already Member..?</span>
                                <Link className="fw-semibold" style={{ color: '#6f42c1', fontSize: '1.05rem' }} to="/login">Login</Link>
                            </div>
                            <div className="card-footer py-3 d-flex justify-content-center login-footer">
                                <span className="fw-bold me-1" style={{ color: '#9c0828ff', fontSize: '1.15rem' }}>New Here?</span>
                                <Link className="fw-semibold " style={{ color: '#6f42c1', fontSize: '1.05rem' }} to="/Registration">Sign Up</Link>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default Forgot;
